// extracted by mini-css-extract-plugin
module.exports = {"hide":"Page-module--hide--3u-mY"};